import { estiloColores } from "./colores";

export const estiloSegmento = {
  Pasajero: {
    marginTop: "-14px",
    borderColor: estiloColores.Blanco,
    backgroundColor: "white",
    borderRadius: "0px",
    borderStyle: "none",
    boxShadow: "0 0px 0px 0 rgba(34,36,38,.15)",
  },

  Conductor: {
    marginTop: "-14px",
    borderColor: estiloColores.Blanco,
    backgroundColor: "white",
    borderRadius: "0px",
    borderStyle: "none",
    boxShadow: "0 0px 0px 0 rgba(34,36,38,.15)",
  },

  Administrador: {
    marginTop: "-14px",
    borderColor: estiloColores.Blanco,
    backgroundColor: "white",
    borderRadius: "0px",
    borderStyle: "none",
    boxShadow: "0 0px 0px 0 rgba(34,36,38,.15)",
  },
};
